import React from 'react'

export default function DashboardControls({ 
  timeRange, 
  onTimeRangeChange, 
  selectedBuoy, 
  onBuoyChange, 
  availableBuoys 
}) {
  return (
    <div style={{ 
      display: 'flex', 
      gap: '1rem', 
      marginBottom: '2rem',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap'
    }}>
      <div>
        <label style={{ 
          marginRight: '0.5rem', 
          fontWeight: '500',
          color: '#495057'
        }}>
          Time Range:
        </label>
        <select
          value={timeRange}
          onChange={onTimeRangeChange}
          style={{
            padding: '0.5rem',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            fontSize: '1rem',
            backgroundColor: 'white',
            color: '#495057',
            cursor: 'pointer'
          }}
        >
          <option value="-1h">Last Hour</option>
          <option value="-6h">Last 6 Hours</option>
          <option value="-12h">Last 12 Hours</option>
          <option value="-24h">Last 24 Hours</option>
          <option value="-7d">Last 7 Days</option>
        </select>
      </div>

      <div>
        <label style={{ 
          marginRight: '0.5rem', 
          fontWeight: '500',
          color: '#495057'
        }}>
          Monitoring Buoy:
        </label>
        <select
          value={selectedBuoy}
          onChange={onBuoyChange}
          style={{
            padding: '0.5rem',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            fontSize: '1rem',
            backgroundColor: 'white',
            color: '#495057',
            cursor: 'pointer'
          }}
        >
          {availableBuoys.map(buoy => (
            <option key={buoy} value={buoy}>{buoy}</option>
          ))}
        </select>
      </div>
    </div>
  )
}